import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet/Sheet";
import { format } from "date-fns";
import { useEffect, useState, type Dispatch, type SetStateAction } from "react";
import { useSignUp } from "../../hooks/signUp/useSignUp";
import { SingletonSignUpForm } from "../../forms/signUp/SingletonSignUpForm";
import { MultiWeekSignUpForm } from "../../forms/signUp/MultiWeekSignUpForm";

const SignUpSheet = ({
  open,
  onOpenChange,
  data,
  setRotations,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  data: { rotation: any; session: any };
  setRotations: Dispatch<
    SetStateAction<{
      rotations: any[];
      sessions: any[];
      enrollments: any[];
      preferences: any[];
    }>
  >;
}) => {
  const [explorations, setExplorations] = useState<any[]>([]);

  const { loadExplorations, loading } = useSignUp();

  useEffect(() => {
    if (!data.session) return;
    loadExplorations(data.session._id, setExplorations);
  }, [data.session]);

  const onSuccess = ({
    enrollment,
    preferences,
  }: {
    enrollment?: any;
    preferences?: any;
  }) => {
    onOpenChange(false);
    enrollment &&
      setRotations((prev) => ({
        ...prev,
        enrollments: [...prev.enrollments, enrollment],
      }));
    preferences &&
      setRotations((prev) => ({
        ...prev,
        preferences: [...prev.preferences, preferences],
      }));
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>
            Sign Up for {data.session.name} on{" "}
            {format(data.rotation.date, "MMMM dd, yyyy")}
          </SheetTitle>
          <SheetDescription>
            {data.session.singleton ? "Sign up" : "Submit preferences"} for{" "}
            {data.session.name} on {format(data.rotation.date, "MMMM dd, yyyy")}
            .
          </SheetDescription>
        </SheetHeader>
        {data.session.singleton ? (
          <SingletonSignUpForm
            data={{ explorations, sessionId: data.session._id }}
            loading={loading.loadExplorations}
            onSuccess={onSuccess}
          />
        ) : (
          <MultiWeekSignUpForm
            data={{ explorations, sessionId: data.session._id }}
            loading={loading.loadExplorations}
            onSuccess={onSuccess}
          />
        )}
      </SheetContent>
    </Sheet>
  );
};

export { SignUpSheet };
